import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import api from '../services/api';
import './Auth.css';

function VerifyEmail() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        verifyEmail();
    }, [token]);

    const verifyEmail = async () => {
        try {
            const response = await api.get(`/auth/verify-email/${token}`);
            setStatus('success');
            setMessage(response.data.message || 'Email verified successfully!');

            // Redirect to login after 3 seconds
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            setStatus('error');
            setMessage(error.response?.data?.error || 'Email verification failed. The link may be invalid or expired.');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <h1>Email Verification</h1>
                </div>

                <div className="verification-status">
                    {status === 'verifying' && (
                        <>
                            <Loader2 size={64} className="spinner" />
                            <h2>Verifying your email...</h2>
                            <p>Please wait while we verify your email address.</p>
                        </>
                    )}

                    {status === 'success' && (
                        <>
                            <CheckCircle size={64} className="success-icon" />
                            <h2>Email Verified!</h2>
                            <p>{message}</p>
                            <p className="redirect-message">Redirecting to login...</p>
                        </>
                    )}

                    {status === 'error' && (
                        <>
                            <XCircle size={64} className="error-icon" />
                            <h2>Verification Failed</h2>
                            <p>{message}</p>
                            <div className="auth-links">
                                <Link to="/login" className="btn btn-primary">
                                    Go to Login
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default VerifyEmail;
